import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"padding":"0 40px"} }
const _hoisted_2 = {
  key: 1,
  style: {"margin-top":"1rem","margin-bottom":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BadgeList = _resolveComponent("BadgeList")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, {
      ref: "loading",
      minHeight: "40vh"
    }, {
      default: _withCtx(() => [
        (_ctx.badgeProjectList.length)
          ? (_openBlock(), _createBlock(_component_BadgeList, {
              key: 0,
              badgeProjectList: _ctx.badgeProjectList,
              showDisplaySwitch: false
            }, null, 8, ["badgeProjectList"]))
          : (_openBlock(), _createElementBlock("h5", _hoisted_2, "公開バッジはありません"))
      ]),
      _: 1
    }, 512)
  ]))
}